export default __webpack_public_path__ + "static/media/drink6.19fc1e11.jpg";